import { useState } from 'react';
import MyTopNav from 'lib/components/Nav/TopNav';
import { CurrentUser } from 'lib/definitions';
import { CurrentUserContext } from 'lib/hooks';
import { ThemeUIProvider } from 'theme-ui';
import { theme, widths } from './theme';

export default function TopNavApp({ currentUser: initialCurrentUser }) {
  const [currentUser, setCurrentUser] = useState<CurrentUser>(initialCurrentUser);

  const changeCurrentUser = user => {
    setCurrentUser(user);
  }

  return (
    <ThemeUIProvider theme={theme}>
      <CurrentUserContext.Provider value={{ currentUser, changeCurrentUser }}>
        <MyTopNav
          id="top-nav"
          height={52}
          width={widths}
          sx={{
            px: 3,
            textShadow: 'none'
          }}
        />
      </CurrentUserContext.Provider>
    </ThemeUIProvider>
  );
}
